import { render, staticRenderFns } from "./backEditTenderingMessage.vue?vue&type=template&id=1d5bab57&scoped=true"
import script from "./backEditTenderingMessage.vue?vue&type=script&lang=js"
export * from "./backEditTenderingMessage.vue?vue&type=script&lang=js"
import style0 from "./backEditTenderingMessage.vue?vue&type=style&index=0&id=1d5bab57&prod&lang=less&scoped=true"
import style1 from "./backEditTenderingMessage.vue?vue&type=style&index=1&id=1d5bab57&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bab57",
  null
  
)

export default component.exports